module.exports = __webpack_public_path__ + "img/logo-peace.3d2193a9.png";